import { render, staticRenderFns } from "./i-tick-box.vue?vue&type=template&id=2a7128db&scoped=true&"
import script from "./i-tick-box.vue?vue&type=script&lang=js&"
export * from "./i-tick-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7128db",
  null
  
)

export default component.exports